<div id="main-wrapper">
  <header class="topbar">
    <app-navbar></app-navbar>
  </header>
  <aside class="left-sidebar">
    <div class="d-flex no-block nav-text-box align-items-center">
      <span><img src="assets/images/favicon.png" width="100" alt="elegant admin template"></span>
      <a class="nav-lock waves-effect waves-dark ml-auto hidden-md-down" href="javascript:void(0)"><i
      class="mdi mdi-toggle-switch"></i></a>
      <a class="nav-toggler waves-effect waves-dark ml-auto hidden-sm-up" href="javascript:void(0)"><i
      class="ti-menu ti-close"></i></a>
    </div>
    <div class="scroll-sidebar">
      <nav class="sidebar-nav">
        <ul id="sidebarnav">
          <li>
            <a class="has-arrow waves-effect waves-dark" [routerLink]="['/home']" aria-expanded="false">
              <i class="mdi mdi-view-dashboard"></i>
              <span class="hide-menu">
                Home
              </span>
            </a>
            <ul aria-expanded="false" class="collapsed">
              @for (item of options.roles; track item) {
                <li>
                  <a [routerLink]="['/' + item.optionKey]">
                    {{ item.optionDesc }}
                              <i [ngClass]="{
                                'far': item.optionKey === 'menu_datamanagement',
                                'fa-file-alt': item.optionKey === 'menu_datamanagement',
                                'fas': item.optionKey === 'menu_report' || item.optionKey === 'menu_user',
                                'fa-th-large': item.optionKey === 'menu_report',
                                'fa-users': item.optionKey === 'menu_user'
                              }"></i>
                  </a>
                </li>
              }
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  </aside>
  <div class="page-wrapper">
    <router-outlet></router-outlet>
  </div>
</div>
